import { LEAD_REPORTS } from '../../api/endpoints';
import { baseApi } from './baseApi';

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    exportSaleInformation: build.query({
      query: (params = {}) => ({
        url: LEAD_REPORTS.EXPORT_SALE_INFORMATION,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Report', id: 'SALE_INFORMATION' }],
    }),
    getPaymentSummary: build.query({
      query: (params = {}) => ({
        url: LEAD_REPORTS.PAYMENT_SUMMARY,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Report', id: 'PAYMENT_SUMMARY' }],
    }),
    getClientsAsPerStatus: build.query({
      query: (params = {}) => ({
        url: LEAD_REPORTS.CLIENTS_AS_PER_STATUS,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Report', id: 'CLIENTS_AS_PER_STATUS' }],
    }),
  }),
});

export const {
  useExportSaleInformationQuery,
  useLazyExportSaleInformationQuery,
  useGetPaymentSummaryQuery,
  useLazyGetPaymentSummaryQuery,
  useGetClientsAsPerStatusQuery,
  useLazyGetClientsAsPerStatusQuery,
} = reportsApi;
